import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import prop from 'lodash/fp/prop';

import { filterOutUndefinedIds } from '../filterOutUndefinedIds';

export const mapObjectWithIdListToIds = flow(filterOutUndefinedIds, map(prop('id')));
